import "core-js/modules/es.array.concat";
import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
var m = {
  namespaced: true,
  state: {
    nav: '',
    mpVisible: false,
    withdrawType: 'yunzhanghu',
    accountInfo: null,
    prizeDetail: {
      list: [],
      loaded: false,
      requesting: false
    },
    withdrawDetail: {
      list: [],
      loaded: false,
      requesting: false
    },
    checkContract: null,
    contractUrl: {},
    previewContractUrl: {},

    /** 账户余额 */
    account: 0,
    contractType: null
  },
  mutations: {
    setNav: function setNav(state, nav) {
      state.nav = nav;
    },
    setMPVisible: function setMPVisible(state, mpVisible) {
      state.mpVisible = mpVisible;
    },
    setWithdrawType: function setWithdrawType(state, withdrawType) {
      state.withdrawType = withdrawType;
    },

    /**
     * 记录账号信息
     */
    setAccountInfo: function setAccountInfo(state, accountInfo) {
      state.accountInfo = accountInfo;
    },

    /**
     * 添加prizeDetail
     */
    concatPrizeDetail: function concatPrizeDetail(state, list) {
      state.prizeDetail.list = state.prizeDetail.list.concat(list);
    },

    /**
     * 记录prizeDetail的req
     */
    setPrizeDetailReq: function setPrizeDetailReq(state, req) {
      state.prizeDetail.requesting = req;
    },

    /**
     * 记录prizeDetail的loaded
     */
    setPrizeDetailLoaded: function setPrizeDetailLoaded(state, loaded) {
      state.prizeDetail.loaded = loaded;
    },

    /**
     * 添加withdrawDetail
     */
    concatWithdrawDetail: function concatWithdrawDetail(state, list) {
      state.withdrawDetail.list = state.withdrawDetail.list.concat(list);
    },

    /**
     * 记录withdrawDetail的req
     */
    setWithdrawDetailReq: function setWithdrawDetailReq(state, req) {
      state.withdrawDetail.requesting = req;
    },

    /**
     * 记录withdrawDetail的loaded
     */
    setWithdrawDetailLoaded: function setWithdrawDetailLoaded(state, loaded) {
      state.withdrawDetail.loaded = loaded;
    },

    /**
     * 记录check Contract数据
     */
    setCheckContract: function setCheckContract(state, checkContract) {
      state.checkContract = checkContract;
    },
    setContractUrl: function setContractUrl(state, _a) {
      var activityId = _a.activityId,
          contractUrl = _a.contractUrl;
      Vue.set(state.contractUrl, activityId, contractUrl);
    },

    /**
     * 记录协议链接
     */
    setPreviewContractUrl: function setPreviewContractUrl(state, _a) {
      var activityId = _a.activityId,
          contractUrl = _a.contractUrl;
      Vue.set(state.previewContractUrl, activityId, contractUrl);
    },

    /**
     * 记录账户余额
     */
    setAccount: function setAccount(state, money) {
      state.account = money;
    },
    setContractType: function setContractType(state, contractType) {
      state.contractType = contractType;
    }
  },
  actions: {
    /**
     * 提现请求
     */
    createContract: function createContract(_a, _b) {
      var state = _a.state,
          dispatch = _a.dispatch;
      var activityId = _b.activityId,
          agreementRead = _b.agreementRead;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/prize/create_contract', {
                id: activityId,
                agreement_read: agreementRead
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 提现请求
     */
    request: function request(_a, _b) {
      var state = _a.state,
          dispatch = _a.dispatch;
      var accountType = _b.accountType,
          account = _b.account,
          channel = _b.channel;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/prize/withdraw', {
                type: accountType,
                account: account,
                channel: channel
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                dispatch({
                  type: 'getAccount',
                  forceUpdate: true
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取账号信息
     */
    getAccountInfo: function getAccountInfo(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var forceUpdate = (_b === void 0 ? {} : _b).forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (state.accountInfo && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/prize/withdraw_method')];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setAccountInfo', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 更新账户信息
     */
    updateAccount: function updateAccount(_a, _b) {
      var state = _a.state,
          dispatch = _a.dispatch;
      var accountType = _b.accountType,
          account = _b.account;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/prize/withdraw_method', {
                type: accountType,
                account: account
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                dispatch('getAccountInfo', {
                  forceUpdate: true
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 奖金明细
     */
    getPrizeDetail: function getPrizeDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (offset === 0 && forceUpdate) {
                state.prizeDetail = {
                  list: [],
                  loaded: false,
                  requesting: false
                };
              }

              wrap = state.prizeDetail;

              if (wrap.loaded || wrap.requesting) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;

              if (end <= wrap.list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < wrap.list.length) {
                offset = wrap.list.length;
                count = end - offset;
              }

              commit('setPrizeDetailReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/prize/prize_detail', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatPrizeDetail', rdata.data);

                if (rdata.data.length < count) {
                  commit('setPrizeDetailLoaded', true);
                }
              }

              commit('setPrizeDetailReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 提现明细
     */
    getWithdrawDetail: function getWithdrawDetail(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var offset = _b.offset,
          count = _b.count,
          forceUpdate = _b.forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var wrap, end, response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              if (offset === 0 && forceUpdate) {
                state.withdrawDetail = {
                  list: [],
                  loaded: false,
                  requesting: false
                };
              }

              wrap = state.withdrawDetail;

              if (wrap.loaded || wrap.requesting) {
                return [2
                /*return*/
                ];
              }

              end = offset + count;

              if (end <= wrap.list.length) {
                return [2
                /*return*/
                ];
              }

              if (offset < wrap.list.length) {
                offset = wrap.list.length;
                count = end - offset;
              }

              commit('setWithdrawDetailReq', true);
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/prize/withdraw_detail', {
                params: {
                  offset: offset,
                  count: count
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('concatWithdrawDetail', rdata.data);

                if (rdata.data.length < count) {
                  commit('setWithdrawDetailLoaded', true);
                }
              }

              commit('setWithdrawDetailReq', false);
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    checkContract: function checkContract(_a) {
      var state = _a.state,
          commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/prize/check_contract')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setCheckContract', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得协议链接
     */
    getContractUrl: function getContractUrl(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/prize/contract_sign_url', {
                params: {
                  id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setContractUrl', {
                  activityId: activityId,
                  contractUrl: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取账户余额
     */
    getAccount: function getAccount(_a, _b) {
      var state = _a.state,
          commit = _a.commit;
      var forceUpdate = (_b === void 0 ? {} : _b).forceUpdate;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/prize/account')];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setAccount', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getContractStatus: function getContractStatus(context, _a) {
      var activityId = _a.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/prize/contract_sign_status', {
                params: {
                  id: activityId
                }
              })];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获得合同链接
     */
    getPreviewContractUrl: function getPreviewContractUrl(_a, _b) {
      var commit = _a.commit;
      var activityId = _b.activityId;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/prize/contract_view_url', {
                params: {
                  id: activityId
                }
              })];

            case 1:
              response = _c.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setPreviewContractUrl', {
                  activityId: activityId,
                  contractUrl: rdata.data
                });
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getContractType: function getContractType(_a, _b) {
      var state = _a.state,
          commit = _a.commit;

      var _c = _b === void 0 ? {} : _b,
          id = _c.id,
          forceUpdate = _c.forceUpdate;

      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_d) {
          switch (_d.label) {
            case 0:
              if (state.contractType && !forceUpdate) {
                return [2
                /*return*/
                ];
              }

              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/prize/contract_type', {
                params: {
                  id: id
                }
              })];

            case 1:
              response = _d.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setContractType', rdata.data);
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },
    getWithdrawType: function getWithdrawType(_a) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/prize/withdraw_channel')];

            case 1:
              response = _b.sent();
              rdata = response.data;

              if (rdata.status === 0) {
                commit('setWithdrawType', rdata.data === '身边云' ? 'shenbianyun' : 'yunzhanghu');
              }

              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 获取身边云签约信息
     */
    youfuSign: function youfuSign(_a) {
      var commit = _a.commit;
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_b) {
          switch (_b.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.get('/api/v1/prize/youfu/sign')];

            case 1:
              response = _b.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    },

    /**
     * 转跑币
     */
    convertCoin: function convertCoin(context, count) {
      return __awaiter(this, void 0, void 0, function () {
        var response, rdata;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4
              /*yield*/
              , Vue.axios.post('/api/v1/prize/convert_coin', {
                count: count
              })];

            case 1:
              response = _a.sent();
              rdata = response.data;
              return [2
              /*return*/
              , rdata];
          }
        });
      });
    }
  }
};
export default m;